interface ActionsIconProps {
  width?: string;
  height?: string;
}

export function ActionsIcon({ width = '41', height = '28', ...rest }: ActionsIconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 41 28'
      fill='none'
      {...rest}
    >
      <rect width='41' height='28' rx='5' fill='#F16622' />
      <ellipse
        cx='10.968'
        cy='14'
        rx='3'
        ry='2.968'
        transform='rotate(-90 10.968 14)'
        fill='white'
      />
      <ellipse
        cx='20.968'
        cy='14'
        rx='3'
        ry='2.968'
        transform='rotate(-90 20.968 14)'
        fill='white'
      />
      <ellipse
        cx='30.968'
        cy='14'
        rx='3'
        ry='2.968'
        transform='rotate(-90 30.968 14)'
        fill='white'
      />
    </svg>
  );
}
